/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * gomedia/pis/pisservice.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as url from "url";
import * as portableFetch from "portable-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "http://localhost".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *  
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 * 
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = portableFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 * 
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError" = "RequiredError";
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface AddUnknownSubscriberRequest
 */
export interface AddUnknownSubscriberRequest {
    /**
     * 
     * @type {VehicleMapping}
     * @memberof AddUnknownSubscriberRequest
     */
    subscriber?: VehicleMapping;
}

/**
 * 
 * @export
 * @interface AddUnknownSubscriberResponse
 */
export interface AddUnknownSubscriberResponse {
}

/**
 * 
 * @export
 * @interface AirportDeparture
 */
export interface AirportDeparture {
    /**
     * 
     * @type {string}
     * @memberof AirportDeparture
     */
    flight_number?: string;
    /**
     * 
     * @type {NameI18n}
     * @memberof AirportDeparture
     */
    destination_name?: NameI18n;
    /**
     * 
     * @type {string}
     * @memberof AirportDeparture
     */
    terminal?: string;
    /**
     * 
     * @type {string}
     * @memberof AirportDeparture
     */
    gate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AirportDeparture
     */
    cancelled?: boolean;
    /**
     * 
     * @type {CallingPointTimes}
     * @memberof AirportDeparture
     */
    departure_times?: CallingPointTimes;
    /**
     * 
     * @type {NameI18n}
     * @memberof AirportDeparture
     */
    airline?: NameI18n;
    /**
     * 
     * @type {string}
     * @memberof AirportDeparture
     */
    airport_code?: string;
    /**
     * 
     * @type {string}
     * @memberof AirportDeparture
     */
    destination_airport_code?: string;
    /**
     * 
     * @type {string}
     * @memberof AirportDeparture
     */
    display_time_zone?: string;
}

/**
 * 
 * @export
 * @interface AirportDepartureList
 */
export interface AirportDepartureList {
    /**
     * 
     * @type {NameI18n}
     * @memberof AirportDepartureList
     */
    airport_name?: NameI18n;
    /**
     * 
     * @type {Array<AirportDeparture>}
     * @memberof AirportDepartureList
     */
    departures?: Array<AirportDeparture>;
}

/**
 * 
 * @export
 * @interface Announcement
 */
export interface Announcement {
    /**
     * 
     * @type {Date}
     * @memberof Announcement
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof Announcement
     */
    type?: string;
    /**
     * 
     * @type {NameI18n}
     * @memberof Announcement
     */
    message?: NameI18n;
    /**
     * 
     * @type {Array<string>}
     * @memberof Announcement
     */
    station_ids?: Array<string>;
}

/**
 * 
 * @export
 * @interface AnnouncementConfig
 */
export interface AnnouncementConfig {
    /**
     * 
     * @type {string}
     * @memberof AnnouncementConfig
     */
    type?: string;
    /**
     * 
     * @type {Date}
     * @memberof AnnouncementConfig
     */
    date?: Date;
    /**
     * 
     * @type {NameI18n}
     * @memberof AnnouncementConfig
     */
    description?: NameI18n;
}

/**
 * 
 * @export
 * @interface AssignedJourney
 */
export interface AssignedJourney {
    /**
     * 
     * @type {string}
     * @memberof AssignedJourney
     */
    subscriber_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedJourney
     */
    journey_id?: string;
    /**
     * 
     * @type {Market}
     * @memberof AssignedJourney
     */
    market?: Market;
    /**
     * 
     * @type {string}
     * @memberof AssignedJourney
     */
    company?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof AssignedJourney
     */
    metadata?: { [key: string]: string; };
}

/**
 * 
 * @export
 * @interface AuthResponse
 */
export interface AuthResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthResponse
     */
    jwt_token?: string;
}

/**
 * 
 * @export
 * @interface CallingPoint
 */
export interface CallingPoint {
    /**
     * 
     * @type {ExternalId}
     * @memberof CallingPoint
     */
    id?: ExternalId;
    /**
     * 
     * @type {CallingPointTimes}
     * @memberof CallingPoint
     */
    arrival_times?: CallingPointTimes;
    /**
     * 
     * @type {CallingPointTimes}
     * @memberof CallingPoint
     */
    departure_times?: CallingPointTimes;
    /**
     * 
     * @type {boolean}
     * @memberof CallingPoint
     */
    cancelled?: boolean;
    /**
     * 
     * @type {CallingPointType}
     * @memberof CallingPoint
     */
    type?: CallingPointType;
    /**
     * 
     * @type {string}
     * @memberof CallingPoint
     */
    platform?: string;
    /**
     * departures from nearest station, airports etc.
     * @type {Array<Departure>}
     * @memberof CallingPoint
     */
    departures?: Array<Departure>;
    /**
     * 
     * @type {NameI18n}
     * @memberof CallingPoint
     */
    station_alert?: NameI18n;
    /**
     * 
     * @type {string}
     * @memberof CallingPoint
     */
    timezone?: string;
}

/**
 * 
 * @export
 * @interface CallingPointTimes
 */
export interface CallingPointTimes {
    /**
     * 
     * @type {Date}
     * @memberof CallingPointTimes
     */
    scheduled_time?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CallingPointTimes
     */
    estimated_time?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CallingPointTimes
     */
    actual_time?: Date;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum CallingPointType {
    CALLINGPOINTTYPEUNSPECIFIED = 'CALLING_POINT_TYPE_UNSPECIFIED',
    INTERMEDIATE = 'INTERMEDIATE',
    ORIGIN = 'ORIGIN',
    DESTINATION = 'DESTINATION'
}

/**
 * 
 * @export
 * @interface CancelReason
 */
export interface CancelReason {
    /**
     * 
     * @type {string}
     * @memberof CancelReason
     */
    id?: string;
    /**
     * 
     * @type {Market}
     * @memberof CancelReason
     */
    market?: Market;
    /**
     * 
     * @type {string}
     * @memberof CancelReason
     */
    toc?: string;
    /**
     * 
     * @type {string}
     * @memberof CancelReason
     */
    toc_code?: string;
    /**
     * 
     * @type {string}
     * @memberof CancelReason
     */
    default_text?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CancelReason
     */
    languages?: { [key: string]: string; };
}

/**
 * 
 * @export
 * @interface CheckApiKeyResponse
 */
export interface CheckApiKeyResponse {
    /**
     * 
     * @type {string}
     * @memberof CheckApiKeyResponse
     */
    toc?: string;
    /**
     * 
     * @type {Market}
     * @memberof CheckApiKeyResponse
     */
    market?: Market;
}

/**
 * 
 * @export
 * @interface CheckShareTokenResponse
 */
export interface CheckShareTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof CheckShareTokenResponse
     */
    journey_id?: string;
}

/**
 * 
 * @export
 * @interface ConnectedVehicles
 */
export interface ConnectedVehicles {
    /**
     * 
     * @type {string}
     * @memberof ConnectedVehicles
     */
    vehicle_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectedVehicles
     */
    journey_id?: string;
    /**
     * 
     * @type {Market}
     * @memberof ConnectedVehicles
     */
    market?: Market;
    /**
     * 
     * @type {string}
     * @memberof ConnectedVehicles
     */
    company?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ConnectedVehicles
     */
    metadata?: { [key: string]: string; };
}

/**
 * 
 * @export
 * @interface CreateRouteResponse
 */
export interface CreateRouteResponse {
}

/**
 * 
 * @export
 * @interface CreateShareMyTrainLinkResponse
 */
export interface CreateShareMyTrainLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateShareMyTrainLinkResponse
     */
    url?: string;
}

/**
 * 
 * @export
 * @interface Departure
 */
export interface Departure {
    /**
     * 
     * @type {AirportDepartureList}
     * @memberof Departure
     */
    airport_departures?: AirportDepartureList;
    /**
     * 
     * @type {TrainDepartureList}
     * @memberof Departure
     */
    train_departures?: TrainDepartureList;
}

/**
 * 
 * @export
 * @interface DepartureAnnouncementConfig
 */
export interface DepartureAnnouncementConfig {
    /**
     * 
     * @type {string}
     * @memberof DepartureAnnouncementConfig
     */
    display_condition?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DepartureAnnouncementConfig
     */
    minutes_before_departure?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DepartureAnnouncementConfig
     */
    acceptable_delay?: string;
    /**
     * 
     * @type {NameI18n}
     * @memberof DepartureAnnouncementConfig
     */
    description?: NameI18n;
}

/**
 * 
 * @export
 * @interface DepartureVideo
 */
export interface DepartureVideo {
    /**
     * 
     * @type {string}
     * @memberof DepartureVideo
     */
    destination_id?: string;
    /**
     * 
     * @type {string}
     * @memberof DepartureVideo
     */
    journey_id?: string;
    /**
     * 
     * @type {string}
     * @memberof DepartureVideo
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof DepartureVideo
     */
    link?: string;
    /**
     * 
     * @type {CallingPointTimes}
     * @memberof DepartureVideo
     */
    departure_times?: CallingPointTimes;
    /**
     * 
     * @type {string}
     * @memberof DepartureVideo
     */
    request_id?: string;
}

/**
 * 
 * @export
 * @interface Direction
 */
export interface Direction {
    /**
     * 
     * @type {string}
     * @memberof Direction
     */
    navigate_from?: string;
    /**
     * 
     * @type {string}
     * @memberof Direction
     */
    navigate_to?: string;
    /**
     * 
     * @type {string}
     * @memberof Direction
     */
    arrow?: string;
    /**
     * 
     * @type {string}
     * @memberof Direction
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof Direction
     */
    accessibility?: string;
}

/**
 * 
 * @export
 * @interface DismissUnknownSubscriberRequest
 */
export interface DismissUnknownSubscriberRequest {
    /**
     * 
     * @type {string}
     * @memberof DismissUnknownSubscriberRequest
     */
    subscriber_id?: string;
    /**
     * 
     * @type {string}
     * @memberof DismissUnknownSubscriberRequest
     */
    toc?: string;
    /**
     * 
     * @type {Market}
     * @memberof DismissUnknownSubscriberRequest
     */
    market?: Market;
    /**
     * 
     * @type {boolean}
     * @memberof DismissUnknownSubscriberRequest
     */
    dismissed?: boolean;
}

/**
 * 
 * @export
 * @interface DismissUnknownSubscriberResponse
 */
export interface DismissUnknownSubscriberResponse {
}

/**
 * 
 * @export
 * @interface DisplayCallingPoint
 */
export interface DisplayCallingPoint {
    /**
     * 
     * @type {CallingPoint}
     * @memberof DisplayCallingPoint
     */
    calling_point?: CallingPoint;
    /**
     * 
     * @type {NameI18n}
     * @memberof DisplayCallingPoint
     */
    display_name?: NameI18n;
    /**
     * 
     * @type {string}
     * @memberof DisplayCallingPoint
     */
    display_time_zone?: string;
    /**
     * 
     * @type {JourneyPhase}
     * @memberof DisplayCallingPoint
     */
    journey_phase?: JourneyPhase;
    /**
     * 
     * @type {Tiploc}
     * @memberof DisplayCallingPoint
     */
    tiploc?: Tiploc;
}

/**
 * 
 * @export
 * @interface ExternalId
 */
export interface ExternalId {
    /**
     * 
     * @type {string}
     * @memberof ExternalId
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalId
     */
    id?: string;
    /**
     * 
     * @type {Market}
     * @memberof ExternalId
     */
    market?: Market;
}

/**
 * 
 * @export
 * @interface Facility
 */
export interface Facility {
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    icon_type?: string;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    warning_message?: string;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    warning_icon?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Facility
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    html?: string;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    link?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Facility
     */
    working_hours?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof Facility
     */
    navigation_mode?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    video_link?: string;
}

/**
 * 
 * @export
 * @interface FailedJourney
 */
export interface FailedJourney {
    /**
     * 
     * @type {Array<FailedJourneyItem>}
     * @memberof FailedJourney
     */
    items?: Array<FailedJourneyItem>;
}

/**
 * 
 * @export
 * @interface FailedJourneyItem
 */
export interface FailedJourneyItem {
    /**
     * 
     * @type {string}
     * @memberof FailedJourneyItem
     */
    subscriber_id?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedJourneyItem
     */
    journey_id?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedJourneyItem
     */
    station_id?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedJourneyItem
     */
    station_position?: string;
    /**
     * 
     * @type {Date}
     * @memberof FailedJourneyItem
     */
    arrival_actual_time?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FailedJourneyItem
     */
    departure_actual_time?: Date;
    /**
     * 
     * @type {number}
     * @memberof FailedJourneyItem
     */
    latitude_station?: number;
    /**
     * 
     * @type {number}
     * @memberof FailedJourneyItem
     */
    longitude_station?: number;
    /**
     * 
     * @type {number}
     * @memberof FailedJourneyItem
     */
    latitude_actual?: number;
    /**
     * 
     * @type {number}
     * @memberof FailedJourneyItem
     */
    longitude_actual?: number;
    /**
     * 
     * @type {number}
     * @memberof FailedJourneyItem
     */
    distance?: number;
    /**
     * 
     * @type {string}
     * @memberof FailedJourneyItem
     */
    toc?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FailedJourneyItem
     */
    failed?: boolean;
}

/**
 * 
 * @export
 * @interface FailedJourneyListItem
 */
export interface FailedJourneyListItem {
    /**
     * 
     * @type {string}
     * @memberof FailedJourneyListItem
     */
    market?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedJourneyListItem
     */
    subscriber_id?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedJourneyListItem
     */
    journey_id?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedJourneyListItem
     */
    toc?: string;
    /**
     * 
     * @type {Date}
     * @memberof FailedJourneyListItem
     */
    update_time?: Date;
}

/**
 * 
 * @export
 * @interface Feedback
 */
export interface Feedback {
    /**
     * 
     * @type {string}
     * @memberof Feedback
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof Feedback
     */
    create_time?: Date;
    /**
     * 
     * @type {string}
     * @memberof Feedback
     */
    journey_response?: string;
    /**
     * 
     * @type {PisSubscriber}
     * @memberof Feedback
     */
    subscriber?: PisSubscriber;
    /**
     * 
     * @type {string}
     * @memberof Feedback
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof Feedback
     */
    user_agent?: string;
    /**
     * 
     * @type {string}
     * @memberof Feedback
     */
    company_name?: string;
}

/**
 * 
 * @export
 * @interface GenerateShareTokenResponse
 */
export interface GenerateShareTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof GenerateShareTokenResponse
     */
    url?: string;
}

/**
 * 
 * @export
 * @interface GetActiveSubscriberResponse
 */
export interface GetActiveSubscriberResponse {
    /**
     * 
     * @type {string}
     * @memberof GetActiveSubscriberResponse
     */
    subscriber_id?: string;
}

/**
 * 
 * @export
 * @interface GetAllDeparturesResponse
 */
export interface GetAllDeparturesResponse {
    /**
     * 
     * @type {Array<Departure>}
     * @memberof GetAllDeparturesResponse
     */
    departures?: Array<Departure>;
}

/**
 * 
 * @export
 * @interface GetAllMarketsResponse
 */
export interface GetAllMarketsResponse {
    /**
     * 
     * @type {Array<Market>}
     * @memberof GetAllMarketsResponse
     */
    items?: Array<Market>;
}

/**
 * 
 * @export
 * @interface GetAllTocsResponse
 */
export interface GetAllTocsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetAllTocsResponse
     */
    items?: Array<string>;
}

/**
 * 
 * @export
 * @interface GetAnnouncementsResponse
 */
export interface GetAnnouncementsResponse {
    /**
     * 
     * @type {Array<AnnouncementConfig>}
     * @memberof GetAnnouncementsResponse
     */
    items?: Array<AnnouncementConfig>;
}

/**
 * 
 * @export
 * @interface GetAssignedJourneysResponse
 */
export interface GetAssignedJourneysResponse {
    /**
     * 
     * @type {Array<AssignedJourney>}
     * @memberof GetAssignedJourneysResponse
     */
    items?: Array<AssignedJourney>;
}

/**
 * 
 * @export
 * @interface GetConnectedVehiclesResponse
 */
export interface GetConnectedVehiclesResponse {
    /**
     * 
     * @type {Array<ConnectedVehicles>}
     * @memberof GetConnectedVehiclesResponse
     */
    items?: Array<ConnectedVehicles>;
}

/**
 * 
 * @export
 * @interface GetCurrentRouteResponse
 */
export interface GetCurrentRouteResponse {
    /**
     * 
     * @type {Array<RoutePoint>}
     * @memberof GetCurrentRouteResponse
     */
    points?: Array<RoutePoint>;
}

/**
 * 
 * @export
 * @interface GetDeparturesResponse
 */
export interface GetDeparturesResponse {
    /**
     * 
     * @type {Array<Departure>}
     * @memberof GetDeparturesResponse
     */
    departures?: Array<Departure>;
}

/**
 * 
 * @export
 * @interface GetDeparturesVideosApiResponse
 */
export interface GetDeparturesVideosApiResponse {
    /**
     * 
     * @type {Array<DepartureVideo>}
     * @memberof GetDeparturesVideosApiResponse
     */
    items?: Array<DepartureVideo>;
}

/**
 * 
 * @export
 * @interface GetDeparturesVideosResponse
 */
export interface GetDeparturesVideosResponse {
    /**
     * 
     * @type {Array<DepartureVideo>}
     * @memberof GetDeparturesVideosResponse
     */
    items?: Array<DepartureVideo>;
}

/**
 * 
 * @export
 * @interface GetDirectionsResponse
 */
export interface GetDirectionsResponse {
    /**
     * 
     * @type {Array<Direction>}
     * @memberof GetDirectionsResponse
     */
    items?: Array<Direction>;
}

/**
 * 
 * @export
 * @interface GetFailedJourneyResponse
 */
export interface GetFailedJourneyResponse {
    /**
     * 
     * @type {FailedJourney}
     * @memberof GetFailedJourneyResponse
     */
    failed_journey?: FailedJourney;
}

/**
 * 
 * @export
 * @interface GetFailedJourneysResponse
 */
export interface GetFailedJourneysResponse {
    /**
     * 
     * @type {Array<FailedJourneyListItem>}
     * @memberof GetFailedJourneysResponse
     */
    items?: Array<FailedJourneyListItem>;
    /**
     * 
     * @type {string}
     * @memberof GetFailedJourneysResponse
     */
    total?: string;
    /**
     * 
     * @type {string}
     * @memberof GetFailedJourneysResponse
     */
    page_count?: string;
    /**
     * 
     * @type {string}
     * @memberof GetFailedJourneysResponse
     */
    page_number?: string;
}

/**
 * 
 * @export
 * @interface GetFeedbacksResponse
 */
export interface GetFeedbacksResponse {
    /**
     * 
     * @type {Array<Feedback>}
     * @memberof GetFeedbacksResponse
     */
    feedback?: Array<Feedback>;
    /**
     * 
     * @type {string}
     * @memberof GetFeedbacksResponse
     */
    total?: string;
}

/**
 * 
 * @export
 * @interface GetJourneyAnnouncementsResponse
 */
export interface GetJourneyAnnouncementsResponse {
    /**
     * 
     * @type {Array<Announcement>}
     * @memberof GetJourneyAnnouncementsResponse
     */
    announcements?: Array<Announcement>;
}

/**
 * 
 * @export
 * @interface GetJourneyFromEngineResponse
 */
export interface GetJourneyFromEngineResponse {
    /**
     * 
     * @type {Journey}
     * @memberof GetJourneyFromEngineResponse
     */
    journey?: Journey;
}

/**
 * 
 * @export
 * @interface GetJourneyResponse
 */
export interface GetJourneyResponse {
    /**
     * 
     * @type {Journey}
     * @memberof GetJourneyResponse
     */
    journey?: Journey;
    /**
     * 
     * @type {string}
     * @memberof GetJourneyResponse
     */
    vehicle_client_version?: string;
    /**
     * 
     * @type {string}
     * @memberof GetJourneyResponse
     */
    frontend_version?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetJourneyResponse
     */
    connected_to_engine?: boolean;
    /**
     * In JSON format, the Duration type is encoded as a string rather than an object, where the string ends in the suffix \"s\" (indicating seconds) and is preceded by the number of seconds, with nanoseconds expressed as fractional seconds. For example, 3 seconds with 0 nanoseconds should be encoded in JSON format as \"3s\", while 3 seconds and 1 nanosecond should be expressed in JSON format as \"3.000000001s\", and 3 seconds and 1 microsecond should be expressed in JSON format as \"3.000001s\".
     * @type {string}
     * @memberof GetJourneyResponse
     */
    duration_since_last_heartbeat?: string;
}

/**
 * 
 * @export
 * @interface GetJourneyStationsResponse
 */
export interface GetJourneyStationsResponse {
    /**
     * 
     * @type {Array<Tiploc>}
     * @memberof GetJourneyStationsResponse
     */
    items?: Array<Tiploc>;
}

/**
 * 
 * @export
 * @interface GetMovingVehiclesResponse
 */
export interface GetMovingVehiclesResponse {
    /**
     * 
     * @type {Array<MovingVehicle>}
     * @memberof GetMovingVehiclesResponse
     */
    items?: Array<MovingVehicle>;
}

/**
 * 
 * @export
 * @interface GetMyJourneyResponse
 */
export interface GetMyJourneyResponse {
    /**
     * 
     * @type {string}
     * @memberof GetMyJourneyResponse
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof GetMyJourneyResponse
     */
    create_time?: Date;
    /**
     * 
     * @type {ProtobufEmpty}
     * @memberof GetMyJourneyResponse
     */
    no_journey?: ProtobufEmpty;
    /**
     * 
     * @type {ProtobufEmpty}
     * @memberof GetMyJourneyResponse
     */
    heartbeat?: ProtobufEmpty;
    /**
     * 
     * @type {Journey}
     * @memberof GetMyJourneyResponse
     */
    journey?: Journey;
    /**
     * 
     * @type {ProtobufEmpty}
     * @memberof GetMyJourneyResponse
     */
    no_engine_connection?: ProtobufEmpty;
    /**
     * 
     * @type {string}
     * @memberof GetMyJourneyResponse
     */
    engine_version?: string;
    /**
     * 
     * @type {string}
     * @memberof GetMyJourneyResponse
     */
    host_name?: string;
}

/**
 * 
 * @export
 * @interface GetNavigationApiRequest
 */
export interface GetNavigationApiRequest {
    /**
     * 
     * @type {Market}
     * @memberof GetNavigationApiRequest
     */
    market?: Market;
    /**
     * 
     * @type {string}
     * @memberof GetNavigationApiRequest
     */
    station_id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetNavigationApiRequest
     */
    location_id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetNavigationApiRequest
     */
    destination_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetNavigationApiRequest
     */
    wheelchair?: boolean;
}

/**
 * 
 * @export
 * @interface GetNavigationApiResponse
 */
export interface GetNavigationApiResponse {
    /**
     * 
     * @type {number}
     * @memberof GetNavigationApiResponse
     */
    code?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetNavigationApiResponse
     */
    navigate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetNavigationApiResponse
     */
    orientation?: string;
    /**
     * 
     * @type {string}
     * @memberof GetNavigationApiResponse
     */
    message?: string;
}

/**
 * 
 * @export
 * @interface GetNavigationByStationApiResponse
 */
export interface GetNavigationByStationApiResponse {
    /**
     * 
     * @type {Array<Direction>}
     * @memberof GetNavigationByStationApiResponse
     */
    items?: Array<Direction>;
}

/**
 * 
 * @export
 * @interface GetRelatedStationsResponse
 */
export interface GetRelatedStationsResponse {
    /**
     * 
     * @type {Array<RelatedStations>}
     * @memberof GetRelatedStationsResponse
     */
    items?: Array<RelatedStations>;
}

/**
 * 
 * @export
 * @interface GetScheduledAnnouncementsResponse
 */
export interface GetScheduledAnnouncementsResponse {
    /**
     * 
     * @type {Array<StationAnnouncement>}
     * @memberof GetScheduledAnnouncementsResponse
     */
    items?: Array<StationAnnouncement>;
}

/**
 * 
 * @export
 * @interface GetStationAnnouncementsConfigResponse
 */
export interface GetStationAnnouncementsConfigResponse {
    /**
     * 
     * @type {StationAnnouncementConfig}
     * @memberof GetStationAnnouncementsConfigResponse
     */
    config?: StationAnnouncementConfig;
}

/**
 * 
 * @export
 * @interface GetStationAnnouncementsResponse
 */
export interface GetStationAnnouncementsResponse {
    /**
     * 
     * @type {Array<StationAnnouncement>}
     * @memberof GetStationAnnouncementsResponse
     */
    items?: Array<StationAnnouncement>;
}

/**
 * 
 * @export
 * @interface GetStationFacilitiesResponse
 */
export interface GetStationFacilitiesResponse {
    /**
     * 
     * @type {Array<Facility>}
     * @memberof GetStationFacilitiesResponse
     */
    items?: Array<Facility>;
}

/**
 * 
 * @export
 * @interface GetStationsResponse
 */
export interface GetStationsResponse {
    /**
     * 
     * @type {Market}
     * @memberof GetStationsResponse
     */
    market?: Market;
    /**
     * 
     * @type {Array<Station>}
     * @memberof GetStationsResponse
     */
    items?: Array<Station>;
}

/**
 * 
 * @export
 * @interface GetUnknownSubscribersResponse
 */
export interface GetUnknownSubscribersResponse {
    /**
     * 
     * @type {Array<UnknownSubscriber>}
     * @memberof GetUnknownSubscribersResponse
     */
    items?: Array<UnknownSubscriber>;
    /**
     * 
     * @type {string}
     * @memberof GetUnknownSubscribersResponse
     */
    page_number?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUnknownSubscribersResponse
     */
    page_count?: string;
}

/**
 * 
 * @export
 * @interface GetVehicleInfoResponse
 */
export interface GetVehicleInfoResponse {
    /**
     * 
     * @type {Array<VehicleUnit>}
     * @memberof GetVehicleInfoResponse
     */
    units?: Array<VehicleUnit>;
    /**
     * 
     * @type {string}
     * @memberof GetVehicleInfoResponse
     */
    internet_level?: string;
}

/**
 * 
 * @export
 * @interface GetVehicleMappingResponse
 */
export interface GetVehicleMappingResponse {
    /**
     * 
     * @type {Array<VehicleMapping>}
     * @memberof GetVehicleMappingResponse
     */
    items?: Array<VehicleMapping>;
}

/**
 * 
 * @export
 * @interface JoinJourney
 */
export interface JoinJourney {
    /**
     * 
     * @type {Journey}
     * @memberof JoinJourney
     */
    journey?: Journey;
    /**
     * 
     * @type {ExternalId}
     * @memberof JoinJourney
     */
    calling_point?: ExternalId;
}

/**
 * 
 * @export
 * @interface Journey
 */
export interface Journey {
    /**
     * 
     * @type {string}
     * @memberof Journey
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof Journey
     */
    create_time?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Journey
     */
    update_time?: Date;
    /**
     * 
     * @type {Array<DisplayCallingPoint>}
     * @memberof Journey
     */
    calling_points?: Array<DisplayCallingPoint>;
    /**
     * 
     * @type {boolean}
     * @memberof Journey
     */
    cancelled?: boolean;
    /**
     * 
     * @type {ExternalId}
     * @memberof Journey
     */
    cancel_reason_id?: ExternalId;
    /**
     * 
     * @type {SplitJourney}
     * @memberof Journey
     */
    split_journey?: SplitJourney;
    /**
     * 
     * @type {JoinJourney}
     * @memberof Journey
     */
    join_journey?: JoinJourney;
    /**
     * 
     * @type {Vehicle}
     * @memberof Journey
     */
    vehicle?: Vehicle;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Journey
     */
    metadata?: { [key: string]: string; };
    /**
     * 
     * @type {Route}
     * @memberof Journey
     */
    route?: Route;
    /**
     * 
     * @type {string}
     * @memberof Journey
     */
    toc?: string;
    /**
     * 
     * @type {Array<Announcement>}
     * @memberof Journey
     */
    announcements?: Array<Announcement>;
}

/**
 * - JOURNEY_PHASE_UNSPECIFIED: The first value represents the default and must be == 0
 * @export
 * @enum {string}
 */
export enum JourneyPhase {
    JOURNEYPHASEUNSPECIFIED = 'JOURNEY_PHASE_UNSPECIFIED',
    PASSED = 'PASSED',
    CURRENT = 'CURRENT',
    UPCOMING = 'UPCOMING',
    PASSEDINFERRED = 'PASSED_INFERRED'
}

/**
 * - MARKET_UNSPECIFIED: The first value represents the default and must be == 0
 * @export
 * @enum {string}
 */
export enum Market {
    MARKETUNSPECIFIED = 'MARKET_UNSPECIFIED',
    UK = 'UK',
    CH = 'CH',
    US = 'US',
    TFL = 'TFL'
}

/**
 * 
 * @export
 * @interface MovingVehicle
 */
export interface MovingVehicle {
    /**
     * 
     * @type {string}
     * @memberof MovingVehicle
     */
    subscriber_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MovingVehicle
     */
    vehicle_id?: string;
    /**
     * 
     * @type {Market}
     * @memberof MovingVehicle
     */
    market?: Market;
    /**
     * 
     * @type {string}
     * @memberof MovingVehicle
     */
    toc?: string;
    /**
     * 
     * @type {number}
     * @memberof MovingVehicle
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof MovingVehicle
     */
    longitude?: number;
    /**
     * 
     * @type {Date}
     * @memberof MovingVehicle
     */
    generated_at?: Date;
}

/**
 * 
 * @export
 * @interface NameI18n
 */
export interface NameI18n {
    /**
     * values holds translations for the specific name in specific language. Key is language as defined in ISO 639-1.
     * @type {{ [key: string]: string; }}
     * @memberof NameI18n
     */
    values?: { [key: string]: string; };
}

/**
 * 
 * @export
 * @interface PisSubscriber
 */
export interface PisSubscriber {
    /**
     * 
     * @type {string}
     * @memberof PisSubscriber
     */
    name?: string;
}

/**
 * service Foo {       rpc Bar(google.protobuf.Empty) returns (google.protobuf.Empty);     }  The JSON representation for `Empty` is empty JSON object `{}`.
 * @export
 * @interface ProtobufEmpty
 */
export interface ProtobufEmpty {
}

/**
 * 
 * @export
 * @interface RelatedStations
 */
export interface RelatedStations {
    /**
     * 
     * @type {Array<ExternalId>}
     * @memberof RelatedStations
     */
    items?: Array<ExternalId>;
}

/**
 * 
 * @export
 * @interface Route
 */
export interface Route {
    /**
     * 
     * @type {Array<RoutePoint>}
     * @memberof Route
     */
    route_points?: Array<RoutePoint>;
}

/**
 * 
 * @export
 * @interface RoutePoint
 */
export interface RoutePoint {
    /**
     * 
     * @type {string}
     * @memberof RoutePoint
     */
    position?: string;
    /**
     * 
     * @type {number}
     * @memberof RoutePoint
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof RoutePoint
     */
    longitude?: number;
}

/**
 * 
 * @export
 * @interface ScheduledAnnouncementConfig
 */
export interface ScheduledAnnouncementConfig {
    /**
     * 
     * @type {Array<string>}
     * @memberof ScheduledAnnouncementConfig
     */
    periods?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ScheduledAnnouncementConfig
     */
    video_link?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledAnnouncementConfig
     */
    display_frequency?: string;
    /**
     * 
     * @type {NameI18n}
     * @memberof ScheduledAnnouncementConfig
     */
    description?: NameI18n;
}

/**
 * 
 * @export
 * @interface SendConnectedVehiclesResponse
 */
export interface SendConnectedVehiclesResponse {
}

/**
 * 
 * @export
 * @interface SendFeedbackResponse
 */
export interface SendFeedbackResponse {
    /**
     * 
     * @type {string}
     * @memberof SendFeedbackResponse
     */
    feedback_id?: string;
}

/**
 * 
 * @export
 * @interface ShareMyTrainResponse
 */
export interface ShareMyTrainResponse {
    /**
     * 
     * @type {string}
     * @memberof ShareMyTrainResponse
     */
    url?: string;
}

/**
 * 
 * @export
 * @interface SplitJourney
 */
export interface SplitJourney {
    /**
     * 
     * @type {Journey}
     * @memberof SplitJourney
     */
    journey?: Journey;
    /**
     * 
     * @type {ExternalId}
     * @memberof SplitJourney
     */
    calling_point?: ExternalId;
}

/**
 * 
 * @export
 * @interface Station
 */
export interface Station {
    /**
     * 
     * @type {ExternalId}
     * @memberof Station
     */
    id?: ExternalId;
    /**
     * 
     * @type {NameI18n}
     * @memberof Station
     */
    name?: NameI18n;
    /**
     * 
     * @type {number}
     * @memberof Station
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof Station
     */
    longitude?: number;
    /**
     * 
     * @type {string}
     * @memberof Station
     */
    crs?: string;
    /**
     * 
     * @type {string}
     * @memberof Station
     */
    city?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Station
     */
    has_via?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Station
     */
    metadata?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: NameI18n; }}
     * @memberof Station
     */
    lang_features?: { [key: string]: NameI18n; };
}

/**
 * 
 * @export
 * @interface StationAnnouncement
 */
export interface StationAnnouncement {
    /**
     * 
     * @type {string}
     * @memberof StationAnnouncement
     */
    time?: string;
    /**
     * 
     * @type {NameI18n}
     * @memberof StationAnnouncement
     */
    message?: NameI18n;
    /**
     * 
     * @type {string}
     * @memberof StationAnnouncement
     */
    video_link?: string;
}

/**
 * 
 * @export
 * @interface StationAnnouncementConfig
 */
export interface StationAnnouncementConfig {
    /**
     * 
     * @type {Array<DepartureAnnouncementConfig>}
     * @memberof StationAnnouncementConfig
     */
    departures?: Array<DepartureAnnouncementConfig>;
    /**
     * 
     * @type {Array<ScheduledAnnouncementConfig>}
     * @memberof StationAnnouncementConfig
     */
    scheduled?: Array<ScheduledAnnouncementConfig>;
}

/**
 * 
 * @export
 * @interface Tiploc
 */
export interface Tiploc {
    /**
     * 
     * @type {string}
     * @memberof Tiploc
     */
    tiploc?: string;
    /**
     * 
     * @type {NameI18n}
     * @memberof Tiploc
     */
    name?: NameI18n;
    /**
     * 
     * @type {number}
     * @memberof Tiploc
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof Tiploc
     */
    longitude?: number;
    /**
     * 
     * @type {string}
     * @memberof Tiploc
     */
    crs?: string;
    /**
     * 
     * @type {string}
     * @memberof Tiploc
     */
    city?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Tiploc
     */
    metadata?: { [key: string]: string; };
}

/**
 * 
 * @export
 * @interface TrainDeparture
 */
export interface TrainDeparture {
    /**
     * 
     * @type {CallingPointTimes}
     * @memberof TrainDeparture
     */
    departure_times?: CallingPointTimes;
    /**
     * 
     * @type {string}
     * @memberof TrainDeparture
     */
    platform?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TrainDeparture
     */
    cancelled?: boolean;
    /**
     * 
     * @type {ExternalId}
     * @memberof TrainDeparture
     */
    destination_id?: ExternalId;
    /**
     * 
     * @type {NameI18n}
     * @memberof TrainDeparture
     */
    destination_name?: NameI18n;
    /**
     * 
     * @type {string}
     * @memberof TrainDeparture
     */
    display_time_zone?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainDeparture
     */
    via_station?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof TrainDeparture
     */
    metadata?: { [key: string]: string; };
    /**
     * 
     * @type {ExternalId}
     * @memberof TrainDeparture
     */
    journey_id?: ExternalId;
    /**
     * 
     * @type {string}
     * @memberof TrainDeparture
     */
    toc?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainDeparture
     */
    transport_company_name?: string;
}

/**
 * 
 * @export
 * @interface TrainDepartureList
 */
export interface TrainDepartureList {
    /**
     * 
     * @type {Array<TrainDeparture>}
     * @memberof TrainDepartureList
     */
    departures?: Array<TrainDeparture>;
}

/**
 * 
 * @export
 * @interface TrainPosition
 */
export interface TrainPosition {
    /**
     * 
     * @type {number}
     * @memberof TrainPosition
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof TrainPosition
     */
    longitude?: number;
    /**
     * 
     * @type {number}
     * @memberof TrainPosition
     */
    speed?: number;
}

/**
 * 
 * @export
 * @interface UnknownSubscriber
 */
export interface UnknownSubscriber {
    /**
     * 
     * @type {string}
     * @memberof UnknownSubscriber
     */
    subscriber_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UnknownSubscriber
     */
    toc?: string;
    /**
     * 
     * @type {Market}
     * @memberof UnknownSubscriber
     */
    market?: Market;
    /**
     * 
     * @type {Date}
     * @memberof UnknownSubscriber
     */
    last_attempt?: Date;
    /**
     * 
     * @type {string}
     * @memberof UnknownSubscriber
     */
    count_attempt?: string;
    /**
     * 
     * @type {Date}
     * @memberof UnknownSubscriber
     */
    first_attempt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof UnknownSubscriber
     */
    added_to_subscribers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UnknownSubscriber
     */
    dismissed?: boolean;
}

/**
 * 
 * @export
 * @interface UpdateUnknownSubscriberResponse
 */
export interface UpdateUnknownSubscriberResponse {
}

/**
 * 
 * @export
 * @interface Vehicle
 */
export interface Vehicle {
    /**
     * 
     * @type {Array<VehicleUnit>}
     * @memberof Vehicle
     */
    vehicle_units?: Array<VehicleUnit>;
}

/**
 * 
 * @export
 * @interface VehicleMapping
 */
export interface VehicleMapping {
    /**
     * 
     * @type {string}
     * @memberof VehicleMapping
     */
    subscriber_id?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMapping
     */
    vehicle_id?: string;
    /**
     * 
     * @type {Market}
     * @memberof VehicleMapping
     */
    market?: Market;
    /**
     * 
     * @type {string}
     * @memberof VehicleMapping
     */
    transport_company?: string;
}

/**
 * 
 * @export
 * @interface VehicleUnit
 */
export interface VehicleUnit {
    /**
     * 
     * @type {string}
     * @memberof VehicleUnit
     */
    position?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleUnit
     */
    seats_first_class?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleUnit
     */
    seats_second_class?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleUnit
     */
    wheelchair_seats_first_class?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleUnit
     */
    wheelchair_seats_second_class?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleUnit
     */
    beds?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleUnit
     */
    disabled_compartment?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleUnit
     */
    air_conditioner?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleUnit
     */
    bike_platform?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleUnit
     */
    wheelchair_toilets?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleUnit
     */
    wheelchair_restaurant?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleUnit
     */
    emergency_facility?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleUnit
     */
    low_floor?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleUnit
     */
    wheelchair_space?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleUnit
     */
    bicycle_space?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleUnit
     */
    stroller_space?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleUnit
     */
    family_zone?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleUnit
     */
    business_zone?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleUnit
     */
    folding_ramp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleUnit
     */
    auto_gap_bridging?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleUnit
     */
    restaurant?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleUnit
     */
    label?: string;
}


/**
 * ApiServiceApi - fetch parameter creator
 * @export
 */
export const ApiServiceApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [api_key] 
         * @param {string} [api_secret] 
         * @param {string} [rid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShareMyTrainLink(api_key?: string, api_secret?: string, rid?: string, options: any = {}): FetchArgs {
            const localVarPath = `/services/api/v1/share/link`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (api_key !== undefined) {
                localVarQueryParameter['api_key'] = api_key;
            }

            if (api_secret !== undefined) {
                localVarQueryParameter['api_secret'] = api_secret;
            }

            if (rid !== undefined) {
                localVarQueryParameter['rid'] = rid;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartures(market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', id?: string, options: any = {}): FetchArgs {
            const localVarPath = `/services/api/v1/departures`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (market !== undefined) {
                localVarQueryParameter['market'] = market;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetVehicleInfo returns vehicle info
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {string} [station_id] station_id is a station id for which one will be generated sign language videos.
         * @param {Date} [time_from] time_from is set to get station departures starting from a particular time.
         * @param {Date} [time_to] time_to is set to get station departures util a particular time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeparturesVideos(market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', station_id?: string, time_from?: Date, time_to?: Date, options: any = {}): FetchArgs {
            const localVarPath = `/services/api/v1/videos/departures`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (market !== undefined) {
                localVarQueryParameter['market'] = market;
            }

            if (station_id !== undefined) {
                localVarQueryParameter['station_id'] = station_id;
            }

            if (time_from !== undefined) {
                localVarQueryParameter['time_from'] = (time_from as any).toISOString();
            }

            if (time_to !== undefined) {
                localVarQueryParameter['time_to'] = (time_to as any).toISOString();
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CheckShareToken is used to obtain data connected to token
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourney(market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', id?: string, options: any = {}): FetchArgs {
            const localVarPath = `/services/api/v1/journey`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (market !== undefined) {
                localVarQueryParameter['market'] = market;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetSharedJourney requests the journey by token.
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} market market is station market
         * @param {string} station_id station_id is station id where navigation requested
         * @param {GetNavigationApiRequest} GetNavigationApiRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavigation(market: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', station_id: string, GetNavigationApiRequest: GetNavigationApiRequest, options: any = {}): FetchArgs {
            // verify required parameter 'market' is not null or undefined
            if (market === null || market === undefined) {
                throw new RequiredError('market','Required parameter market was null or undefined when calling getNavigation.');
            }
            // verify required parameter 'station_id' is not null or undefined
            if (station_id === null || station_id === undefined) {
                throw new RequiredError('station_id','Required parameter station_id was null or undefined when calling getNavigation.');
            }
            // verify required parameter 'GetNavigationApiRequest' is not null or undefined
            if (GetNavigationApiRequest === null || GetNavigationApiRequest === undefined) {
                throw new RequiredError('GetNavigationApiRequest','Required parameter GetNavigationApiRequest was null or undefined when calling getNavigation.');
            }
            const localVarPath = `/services/api/v1/navigation/{market}/{station_id}`
                .replace(`{${"market"}}`, encodeURIComponent(String(market)))
                .replace(`{${"station_id"}}`, encodeURIComponent(String(station_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GetNavigationApiRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(GetNavigationApiRequest || {}) : (GetNavigationApiRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetActiveSubscriber returns any active journey for company
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} market market is station market
         * @param {string} station_id station_id is station id where navigation requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavigationByStation(market: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', station_id: string, options: any = {}): FetchArgs {
            // verify required parameter 'market' is not null or undefined
            if (market === null || market === undefined) {
                throw new RequiredError('market','Required parameter market was null or undefined when calling getNavigationByStation.');
            }
            // verify required parameter 'station_id' is not null or undefined
            if (station_id === null || station_id === undefined) {
                throw new RequiredError('station_id','Required parameter station_id was null or undefined when calling getNavigationByStation.');
            }
            const localVarPath = `/services/api/v1/navigation/{market}/{station_id}/all`
                .replace(`{${"market"}}`, encodeURIComponent(String(market)))
                .replace(`{${"station_id"}}`, encodeURIComponent(String(station_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetCurrentRoute returns current route
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {string} [station_id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledAnnouncements(market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', station_id?: string, options: any = {}): FetchArgs {
            const localVarPath = `/services/api/v1/scheduled-announcements`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (market !== undefined) {
                localVarQueryParameter['market'] = market;
            }

            if (station_id !== undefined) {
                localVarQueryParameter['station_id'] = station_id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareMyTrainJourney(token?: string, options: any = {}): FetchArgs {
            const localVarPath = `/services/api/v1/share/journey`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetJourneyStations returns stations with coordinates on route for map
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {string} [station_id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStationAnnouncements(market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', station_id?: string, options: any = {}): FetchArgs {
            const localVarPath = `/services/api/v1/station-announcements`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (market !== undefined) {
                localVarQueryParameter['market'] = market;
            }

            if (station_id !== undefined) {
                localVarQueryParameter['station_id'] = station_id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetJourneyByID is used to return current journey by id
         * @param {string} [station_id] 
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStationFacilities(station_id?: string, market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', type?: string, options: any = {}): FetchArgs {
            const localVarPath = `/services/api/v1/facilities`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (station_id !== undefined) {
                localVarQueryParameter['station_id'] = station_id;
            }

            if (market !== undefined) {
                localVarQueryParameter['market'] = market;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiServiceApi - functional programming interface
 * @export
 */
export const ApiServiceApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [api_key] 
         * @param {string} [api_secret] 
         * @param {string} [rid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShareMyTrainLink(api_key?: string, api_secret?: string, rid?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CreateShareMyTrainLinkResponse> {
            const localVarFetchArgs = ApiServiceApiFetchParamCreator(configuration).createShareMyTrainLink(api_key, api_secret, rid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartures(market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', id?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetDeparturesResponse> {
            const localVarFetchArgs = ApiServiceApiFetchParamCreator(configuration).getDepartures(market, id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GetVehicleInfo returns vehicle info
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {string} [station_id] station_id is a station id for which one will be generated sign language videos.
         * @param {Date} [time_from] time_from is set to get station departures starting from a particular time.
         * @param {Date} [time_to] time_to is set to get station departures util a particular time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeparturesVideos(market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', station_id?: string, time_from?: Date, time_to?: Date, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetDeparturesVideosApiResponse> {
            const localVarFetchArgs = ApiServiceApiFetchParamCreator(configuration).getDeparturesVideos(market, station_id, time_from, time_to, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary CheckShareToken is used to obtain data connected to token
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourney(market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', id?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Journey> {
            const localVarFetchArgs = ApiServiceApiFetchParamCreator(configuration).getJourney(market, id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GetSharedJourney requests the journey by token.
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} market market is station market
         * @param {string} station_id station_id is station id where navigation requested
         * @param {GetNavigationApiRequest} GetNavigationApiRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavigation(market: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', station_id: string, GetNavigationApiRequest: GetNavigationApiRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetNavigationApiResponse> {
            const localVarFetchArgs = ApiServiceApiFetchParamCreator(configuration).getNavigation(market, station_id, GetNavigationApiRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GetActiveSubscriber returns any active journey for company
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} market market is station market
         * @param {string} station_id station_id is station id where navigation requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavigationByStation(market: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', station_id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetNavigationByStationApiResponse> {
            const localVarFetchArgs = ApiServiceApiFetchParamCreator(configuration).getNavigationByStation(market, station_id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GetCurrentRoute returns current route
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {string} [station_id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledAnnouncements(market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', station_id?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetScheduledAnnouncementsResponse> {
            const localVarFetchArgs = ApiServiceApiFetchParamCreator(configuration).getScheduledAnnouncements(market, station_id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareMyTrainJourney(token?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetJourneyResponse> {
            const localVarFetchArgs = ApiServiceApiFetchParamCreator(configuration).getShareMyTrainJourney(token, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GetJourneyStations returns stations with coordinates on route for map
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {string} [station_id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStationAnnouncements(market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', station_id?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetStationAnnouncementsResponse> {
            const localVarFetchArgs = ApiServiceApiFetchParamCreator(configuration).getStationAnnouncements(market, station_id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GetJourneyByID is used to return current journey by id
         * @param {string} [station_id] 
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStationFacilities(station_id?: string, market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', type?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetStationFacilitiesResponse> {
            const localVarFetchArgs = ApiServiceApiFetchParamCreator(configuration).getStationFacilities(station_id, market, type, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ApiServiceApi - factory interface
 * @export
 */
export const ApiServiceApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [api_key] 
         * @param {string} [api_secret] 
         * @param {string} [rid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShareMyTrainLink(api_key?: string, api_secret?: string, rid?: string, options?: any) {
            return ApiServiceApiFp(configuration).createShareMyTrainLink(api_key, api_secret, rid, options)(fetch, basePath);
        },
        /**
         * 
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartures(market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', id?: string, options?: any) {
            return ApiServiceApiFp(configuration).getDepartures(market, id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary GetVehicleInfo returns vehicle info
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {string} [station_id] station_id is a station id for which one will be generated sign language videos.
         * @param {Date} [time_from] time_from is set to get station departures starting from a particular time.
         * @param {Date} [time_to] time_to is set to get station departures util a particular time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeparturesVideos(market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', station_id?: string, time_from?: Date, time_to?: Date, options?: any) {
            return ApiServiceApiFp(configuration).getDeparturesVideos(market, station_id, time_from, time_to, options)(fetch, basePath);
        },
        /**
         * 
         * @summary CheckShareToken is used to obtain data connected to token
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourney(market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', id?: string, options?: any) {
            return ApiServiceApiFp(configuration).getJourney(market, id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary GetSharedJourney requests the journey by token.
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} market market is station market
         * @param {string} station_id station_id is station id where navigation requested
         * @param {GetNavigationApiRequest} GetNavigationApiRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavigation(market: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', station_id: string, GetNavigationApiRequest: GetNavigationApiRequest, options?: any) {
            return ApiServiceApiFp(configuration).getNavigation(market, station_id, GetNavigationApiRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary GetActiveSubscriber returns any active journey for company
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} market market is station market
         * @param {string} station_id station_id is station id where navigation requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavigationByStation(market: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', station_id: string, options?: any) {
            return ApiServiceApiFp(configuration).getNavigationByStation(market, station_id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary GetCurrentRoute returns current route
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {string} [station_id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledAnnouncements(market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', station_id?: string, options?: any) {
            return ApiServiceApiFp(configuration).getScheduledAnnouncements(market, station_id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareMyTrainJourney(token?: string, options?: any) {
            return ApiServiceApiFp(configuration).getShareMyTrainJourney(token, options)(fetch, basePath);
        },
        /**
         * 
         * @summary GetJourneyStations returns stations with coordinates on route for map
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {string} [station_id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStationAnnouncements(market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', station_id?: string, options?: any) {
            return ApiServiceApiFp(configuration).getStationAnnouncements(market, station_id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary GetJourneyByID is used to return current journey by id
         * @param {string} [station_id] 
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStationFacilities(station_id?: string, market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', type?: string, options?: any) {
            return ApiServiceApiFp(configuration).getStationFacilities(station_id, market, type, options)(fetch, basePath);
        },
    };
};

/**
 * ApiServiceApi - object-oriented interface
 * @export
 * @class ApiServiceApi
 * @extends {BaseAPI}
 */
export class ApiServiceApi extends BaseAPI {
    /**
     * 
     * @summary Auth is used to obtain JWT token, which should be used for Subscribe
     * @param {string} [api_key] 
     * @param {string} [api_secret] 
     * @param {string} [rid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiServiceApi
     */
    public createShareMyTrainLink(api_key?: string, api_secret?: string, rid?: string, options?: any) {
        return ApiServiceApiFp(this.configuration).createShareMyTrainLink(api_key, api_secret, rid, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
     * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiServiceApi
     */
    public getDepartures(market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', id?: string, options?: any) {
        return ApiServiceApiFp(this.configuration).getDepartures(market, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GetVehicleInfo returns vehicle info
     * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
     * @param {string} [station_id] station_id is a station id for which one will be generated sign language videos.
     * @param {Date} [time_from] time_from is set to get station departures starting from a particular time.
     * @param {Date} [time_to] time_to is set to get station departures util a particular time.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiServiceApi
     */
    public getDeparturesVideos(market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', station_id?: string, time_from?: Date, time_to?: Date, options?: any) {
        return ApiServiceApiFp(this.configuration).getDeparturesVideos(market, station_id, time_from, time_to, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary CheckShareToken is used to obtain data connected to token
     * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiServiceApi
     */
    public getJourney(market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', id?: string, options?: any) {
        return ApiServiceApiFp(this.configuration).getJourney(market, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GetSharedJourney requests the journey by token.
     * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} market market is station market
     * @param {string} station_id station_id is station id where navigation requested
     * @param {GetNavigationApiRequest} GetNavigationApiRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiServiceApi
     */
    public getNavigation(market: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', station_id: string, GetNavigationApiRequest: GetNavigationApiRequest, options?: any) {
        return ApiServiceApiFp(this.configuration).getNavigation(market, station_id, GetNavigationApiRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GetActiveSubscriber returns any active journey for company
     * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} market market is station market
     * @param {string} station_id station_id is station id where navigation requested
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiServiceApi
     */
    public getNavigationByStation(market: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', station_id: string, options?: any) {
        return ApiServiceApiFp(this.configuration).getNavigationByStation(market, station_id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GetCurrentRoute returns current route
     * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
     * @param {string} [station_id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiServiceApi
     */
    public getScheduledAnnouncements(market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', station_id?: string, options?: any) {
        return ApiServiceApiFp(this.configuration).getScheduledAnnouncements(market, station_id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiServiceApi
     */
    public getShareMyTrainJourney(token?: string, options?: any) {
        return ApiServiceApiFp(this.configuration).getShareMyTrainJourney(token, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GetJourneyStations returns stations with coordinates on route for map
     * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
     * @param {string} [station_id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiServiceApi
     */
    public getStationAnnouncements(market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', station_id?: string, options?: any) {
        return ApiServiceApiFp(this.configuration).getStationAnnouncements(market, station_id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GetJourneyByID is used to return current journey by id
     * @param {string} [station_id] 
     * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [market]  - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
     * @param {string} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiServiceApi
     */
    public getStationFacilities(station_id?: string, market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', type?: string, options?: any) {
        return ApiServiceApiFp(this.configuration).getStationFacilities(station_id, market, type, options)(this.fetch, this.basePath);
    }

}

/**
 * DeparturesServiceApi - fetch parameter creator
 * @export
 */
export const DeparturesServiceApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [calling_point_id_type] type specifies the type of the id, for example it can be way to address stations in particular market.
         * @param {string} [calling_point_id_id] id specifies the id of the entity.
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [calling_point_id_market] market defines the market this id belongs to.   - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {Date} [time_from] 
         * @param {Date} [time_to] 
         * @param {string} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartures(calling_point_id_type?: string, calling_point_id_id?: string, calling_point_id_market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', time_from?: Date, time_to?: Date, limit?: string, options: any = {}): FetchArgs {
            const localVarPath = `/services/departures/v1`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (calling_point_id_type !== undefined) {
                localVarQueryParameter['calling_point_id.type'] = calling_point_id_type;
            }

            if (calling_point_id_id !== undefined) {
                localVarQueryParameter['calling_point_id.id'] = calling_point_id_id;
            }

            if (calling_point_id_market !== undefined) {
                localVarQueryParameter['calling_point_id.market'] = calling_point_id_market;
            }

            if (time_from !== undefined) {
                localVarQueryParameter['time_from'] = (time_from as any).toISOString();
            }

            if (time_to !== undefined) {
                localVarQueryParameter['time_to'] = (time_to as any).toISOString();
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeparturesServiceApi - functional programming interface
 * @export
 */
export const DeparturesServiceApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [calling_point_id_type] type specifies the type of the id, for example it can be way to address stations in particular market.
         * @param {string} [calling_point_id_id] id specifies the id of the entity.
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [calling_point_id_market] market defines the market this id belongs to.   - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {Date} [time_from] 
         * @param {Date} [time_to] 
         * @param {string} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartures(calling_point_id_type?: string, calling_point_id_id?: string, calling_point_id_market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', time_from?: Date, time_to?: Date, limit?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetDeparturesResponse> {
            const localVarFetchArgs = DeparturesServiceApiFetchParamCreator(configuration).getDepartures(calling_point_id_type, calling_point_id_id, calling_point_id_market, time_from, time_to, limit, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DeparturesServiceApi - factory interface
 * @export
 */
export const DeparturesServiceApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [calling_point_id_type] type specifies the type of the id, for example it can be way to address stations in particular market.
         * @param {string} [calling_point_id_id] id specifies the id of the entity.
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [calling_point_id_market] market defines the market this id belongs to.   - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {Date} [time_from] 
         * @param {Date} [time_to] 
         * @param {string} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartures(calling_point_id_type?: string, calling_point_id_id?: string, calling_point_id_market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', time_from?: Date, time_to?: Date, limit?: string, options?: any) {
            return DeparturesServiceApiFp(configuration).getDepartures(calling_point_id_type, calling_point_id_id, calling_point_id_market, time_from, time_to, limit, options)(fetch, basePath);
        },
    };
};

/**
 * DeparturesServiceApi - object-oriented interface
 * @export
 * @class DeparturesServiceApi
 * @extends {BaseAPI}
 */
export class DeparturesServiceApi extends BaseAPI {
    /**
     * 
     * @summary Auth is used to obtain JWT token, which should be used for Subscribe
     * @param {string} [calling_point_id_type] type specifies the type of the id, for example it can be way to address stations in particular market.
     * @param {string} [calling_point_id_id] id specifies the id of the entity.
     * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [calling_point_id_market] market defines the market this id belongs to.   - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
     * @param {Date} [time_from] 
     * @param {Date} [time_to] 
     * @param {string} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeparturesServiceApi
     */
    public getDepartures(calling_point_id_type?: string, calling_point_id_id?: string, calling_point_id_market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', time_from?: Date, time_to?: Date, limit?: string, options?: any) {
        return DeparturesServiceApiFp(this.configuration).getDepartures(calling_point_id_type, calling_point_id_id, calling_point_id_market, time_from, time_to, limit, options)(this.fetch, this.basePath);
    }

}

/**
 * EngineWebServiceApi - fetch parameter creator
 * @export
 */
export const EngineWebServiceApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignedJourneys(options: any = {}): FetchArgs {
            const localVarPath = `/services/engine/v1/assigned-journeys`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectedVehicles(options: any = {}): FetchArgs {
            const localVarPath = `/services/engine/v1/connected-vehicles`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} market 
         * @param {string} journey_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourney(market: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', journey_id: string, options: any = {}): FetchArgs {
            // verify required parameter 'market' is not null or undefined
            if (market === null || market === undefined) {
                throw new RequiredError('market','Required parameter market was null or undefined when calling getJourney.');
            }
            // verify required parameter 'journey_id' is not null or undefined
            if (journey_id === null || journey_id === undefined) {
                throw new RequiredError('journey_id','Required parameter journey_id was null or undefined when calling getJourney.');
            }
            const localVarPath = `/services/engine/v1/journey/{market}/{journey_id}`
                .replace(`{${"market"}}`, encodeURIComponent(String(market)))
                .replace(`{${"journey_id"}}`, encodeURIComponent(String(journey_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EngineWebServiceApi - functional programming interface
 * @export
 */
export const EngineWebServiceApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignedJourneys(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetAssignedJourneysResponse> {
            const localVarFetchArgs = EngineWebServiceApiFetchParamCreator(configuration).getAssignedJourneys(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectedVehicles(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetConnectedVehiclesResponse> {
            const localVarFetchArgs = EngineWebServiceApiFetchParamCreator(configuration).getConnectedVehicles(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} market 
         * @param {string} journey_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourney(market: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', journey_id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetJourneyFromEngineResponse> {
            const localVarFetchArgs = EngineWebServiceApiFetchParamCreator(configuration).getJourney(market, journey_id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * EngineWebServiceApi - factory interface
 * @export
 */
export const EngineWebServiceApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignedJourneys(options?: any) {
            return EngineWebServiceApiFp(configuration).getAssignedJourneys(options)(fetch, basePath);
        },
        /**
         * 
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectedVehicles(options?: any) {
            return EngineWebServiceApiFp(configuration).getConnectedVehicles(options)(fetch, basePath);
        },
        /**
         * 
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} market 
         * @param {string} journey_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourney(market: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', journey_id: string, options?: any) {
            return EngineWebServiceApiFp(configuration).getJourney(market, journey_id, options)(fetch, basePath);
        },
    };
};

/**
 * EngineWebServiceApi - object-oriented interface
 * @export
 * @class EngineWebServiceApi
 * @extends {BaseAPI}
 */
export class EngineWebServiceApi extends BaseAPI {
    /**
     * 
     * @summary Auth is used to obtain JWT token, which should be used for Subscribe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EngineWebServiceApi
     */
    public getAssignedJourneys(options?: any) {
        return EngineWebServiceApiFp(this.configuration).getAssignedJourneys(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EngineWebServiceApi
     */
    public getConnectedVehicles(options?: any) {
        return EngineWebServiceApiFp(this.configuration).getConnectedVehicles(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
     * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} market 
     * @param {string} journey_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EngineWebServiceApi
     */
    public getJourney(market: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', journey_id: string, options?: any) {
        return EngineWebServiceApiFp(this.configuration).getJourney(market, journey_id, options)(this.fetch, this.basePath);
    }

}

/**
 * PisFeedbackServiceApi - fetch parameter creator
 * @export
 */
export const PisFeedbackServiceApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [page] page represent page number what should be sent from 0 - first page.
         * @param {string} [size] page_size represents size of output array.
         * @param {Date} [from_date] from_date using to search feedbacks from some date.
         * @param {Date} [to_date] to_date using to search feedbacks to some date.
         * @param {string} [query] query using to search feedbacks from some journey text.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedbacks(page?: string, size?: string, from_date?: Date, to_date?: Date, query?: string, options: any = {}): FetchArgs {
            const localVarPath = `/services/pisfeedbackservice/v1/feedback`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (from_date !== undefined) {
                localVarQueryParameter['from_date'] = (from_date as any).toISOString();
            }

            if (to_date !== undefined) {
                localVarQueryParameter['to_date'] = (to_date as any).toISOString();
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {Feedback} Feedback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFeedback(Feedback: Feedback, options: any = {}): FetchArgs {
            // verify required parameter 'Feedback' is not null or undefined
            if (Feedback === null || Feedback === undefined) {
                throw new RequiredError('Feedback','Required parameter Feedback was null or undefined when calling sendFeedback.');
            }
            const localVarPath = `/services/pisfeedbackservice/v1/feedback`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Feedback" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(Feedback || {}) : (Feedback || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PisFeedbackServiceApi - functional programming interface
 * @export
 */
export const PisFeedbackServiceApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [page] page represent page number what should be sent from 0 - first page.
         * @param {string} [size] page_size represents size of output array.
         * @param {Date} [from_date] from_date using to search feedbacks from some date.
         * @param {Date} [to_date] to_date using to search feedbacks to some date.
         * @param {string} [query] query using to search feedbacks from some journey text.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedbacks(page?: string, size?: string, from_date?: Date, to_date?: Date, query?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetFeedbacksResponse> {
            const localVarFetchArgs = PisFeedbackServiceApiFetchParamCreator(configuration).getFeedbacks(page, size, from_date, to_date, query, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {Feedback} Feedback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFeedback(Feedback: Feedback, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SendFeedbackResponse> {
            const localVarFetchArgs = PisFeedbackServiceApiFetchParamCreator(configuration).sendFeedback(Feedback, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * PisFeedbackServiceApi - factory interface
 * @export
 */
export const PisFeedbackServiceApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [page] page represent page number what should be sent from 0 - first page.
         * @param {string} [size] page_size represents size of output array.
         * @param {Date} [from_date] from_date using to search feedbacks from some date.
         * @param {Date} [to_date] to_date using to search feedbacks to some date.
         * @param {string} [query] query using to search feedbacks from some journey text.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedbacks(page?: string, size?: string, from_date?: Date, to_date?: Date, query?: string, options?: any) {
            return PisFeedbackServiceApiFp(configuration).getFeedbacks(page, size, from_date, to_date, query, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {Feedback} Feedback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFeedback(Feedback: Feedback, options?: any) {
            return PisFeedbackServiceApiFp(configuration).sendFeedback(Feedback, options)(fetch, basePath);
        },
    };
};

/**
 * PisFeedbackServiceApi - object-oriented interface
 * @export
 * @class PisFeedbackServiceApi
 * @extends {BaseAPI}
 */
export class PisFeedbackServiceApi extends BaseAPI {
    /**
     * 
     * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
     * @param {string} [page] page represent page number what should be sent from 0 - first page.
     * @param {string} [size] page_size represents size of output array.
     * @param {Date} [from_date] from_date using to search feedbacks from some date.
     * @param {Date} [to_date] to_date using to search feedbacks to some date.
     * @param {string} [query] query using to search feedbacks from some journey text.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PisFeedbackServiceApi
     */
    public getFeedbacks(page?: string, size?: string, from_date?: Date, to_date?: Date, query?: string, options?: any) {
        return PisFeedbackServiceApiFp(this.configuration).getFeedbacks(page, size, from_date, to_date, query, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Auth is used to obtain JWT token, which should be used for Subscribe
     * @param {Feedback} Feedback 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PisFeedbackServiceApi
     */
    public sendFeedback(Feedback: Feedback, options?: any) {
        return PisFeedbackServiceApiFp(this.configuration).sendFeedback(Feedback, options)(this.fetch, this.basePath);
    }

}

/**
 * RegistryWebServiceApi - fetch parameter creator
 * @export
 */
export const RegistryWebServiceApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {AddUnknownSubscriberRequest} AddUnknownSubscriberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUnknownSubscriber(AddUnknownSubscriberRequest: AddUnknownSubscriberRequest, options: any = {}): FetchArgs {
            // verify required parameter 'AddUnknownSubscriberRequest' is not null or undefined
            if (AddUnknownSubscriberRequest === null || AddUnknownSubscriberRequest === undefined) {
                throw new RequiredError('AddUnknownSubscriberRequest','Required parameter AddUnknownSubscriberRequest was null or undefined when calling addUnknownSubscriber.');
            }
            const localVarPath = `/services/registry/v1/add-unknown-subscriber`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AddUnknownSubscriberRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(AddUnknownSubscriberRequest || {}) : (AddUnknownSubscriberRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {DismissUnknownSubscriberRequest} DismissUnknownSubscriberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissUnknownSubscriber(DismissUnknownSubscriberRequest: DismissUnknownSubscriberRequest, options: any = {}): FetchArgs {
            // verify required parameter 'DismissUnknownSubscriberRequest' is not null or undefined
            if (DismissUnknownSubscriberRequest === null || DismissUnknownSubscriberRequest === undefined) {
                throw new RequiredError('DismissUnknownSubscriberRequest','Required parameter DismissUnknownSubscriberRequest was null or undefined when calling dismissUnknownSubscriber.');
            }
            const localVarPath = `/services/registry/v1/dismiss-unknown-subscriber`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DismissUnknownSubscriberRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(DismissUnknownSubscriberRequest || {}) : (DismissUnknownSubscriberRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetJourneyByID is used to return current journey by id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMarkets(options: any = {}): FetchArgs {
            const localVarPath = `/services/registry/v1/markets`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CheckShareToken is used to obtain data connected to token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTocs(options: any = {}): FetchArgs {
            const localVarPath = `/services/registry/v1/tocs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [toc] 
         * @param {string} [market] 
         * @param {string} [subscriber_id] 
         * @param {string} [page_size] 
         * @param {string} [page_number] 
         * @param {number} [added] added is represented as: 0 -&gt; empty value, 1 -&gt; true, 2 -&gt; false.
         * @param {number} [dismissed] dismissed is represented as: 0 -&gt; empty value, 1 -&gt; true, 2 -&gt; false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnknownSubscribers(toc?: string, market?: string, subscriber_id?: string, page_size?: string, page_number?: string, added?: number, dismissed?: number, options: any = {}): FetchArgs {
            const localVarPath = `/services/registry/v1/unknown-subscribers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (toc !== undefined) {
                localVarQueryParameter['toc'] = toc;
            }

            if (market !== undefined) {
                localVarQueryParameter['market'] = market;
            }

            if (subscriber_id !== undefined) {
                localVarQueryParameter['subscriber_id'] = subscriber_id;
            }

            if (page_size !== undefined) {
                localVarQueryParameter['page_size'] = page_size;
            }

            if (page_number !== undefined) {
                localVarQueryParameter['page_number'] = page_number;
            }

            if (added !== undefined) {
                localVarQueryParameter['added'] = added;
            }

            if (dismissed !== undefined) {
                localVarQueryParameter['dismissed'] = dismissed;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegistryWebServiceApi - functional programming interface
 * @export
 */
export const RegistryWebServiceApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {AddUnknownSubscriberRequest} AddUnknownSubscriberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUnknownSubscriber(AddUnknownSubscriberRequest: AddUnknownSubscriberRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AddUnknownSubscriberResponse> {
            const localVarFetchArgs = RegistryWebServiceApiFetchParamCreator(configuration).addUnknownSubscriber(AddUnknownSubscriberRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {DismissUnknownSubscriberRequest} DismissUnknownSubscriberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissUnknownSubscriber(DismissUnknownSubscriberRequest: DismissUnknownSubscriberRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DismissUnknownSubscriberResponse> {
            const localVarFetchArgs = RegistryWebServiceApiFetchParamCreator(configuration).dismissUnknownSubscriber(DismissUnknownSubscriberRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GetJourneyByID is used to return current journey by id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMarkets(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetAllMarketsResponse> {
            const localVarFetchArgs = RegistryWebServiceApiFetchParamCreator(configuration).getAllMarkets(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary CheckShareToken is used to obtain data connected to token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTocs(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetAllTocsResponse> {
            const localVarFetchArgs = RegistryWebServiceApiFetchParamCreator(configuration).getAllTocs(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [toc] 
         * @param {string} [market] 
         * @param {string} [subscriber_id] 
         * @param {string} [page_size] 
         * @param {string} [page_number] 
         * @param {number} [added] added is represented as: 0 -&gt; empty value, 1 -&gt; true, 2 -&gt; false.
         * @param {number} [dismissed] dismissed is represented as: 0 -&gt; empty value, 1 -&gt; true, 2 -&gt; false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnknownSubscribers(toc?: string, market?: string, subscriber_id?: string, page_size?: string, page_number?: string, added?: number, dismissed?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetUnknownSubscribersResponse> {
            const localVarFetchArgs = RegistryWebServiceApiFetchParamCreator(configuration).getUnknownSubscribers(toc, market, subscriber_id, page_size, page_number, added, dismissed, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * RegistryWebServiceApi - factory interface
 * @export
 */
export const RegistryWebServiceApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {AddUnknownSubscriberRequest} AddUnknownSubscriberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUnknownSubscriber(AddUnknownSubscriberRequest: AddUnknownSubscriberRequest, options?: any) {
            return RegistryWebServiceApiFp(configuration).addUnknownSubscriber(AddUnknownSubscriberRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {DismissUnknownSubscriberRequest} DismissUnknownSubscriberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissUnknownSubscriber(DismissUnknownSubscriberRequest: DismissUnknownSubscriberRequest, options?: any) {
            return RegistryWebServiceApiFp(configuration).dismissUnknownSubscriber(DismissUnknownSubscriberRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary GetJourneyByID is used to return current journey by id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMarkets(options?: any) {
            return RegistryWebServiceApiFp(configuration).getAllMarkets(options)(fetch, basePath);
        },
        /**
         * 
         * @summary CheckShareToken is used to obtain data connected to token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTocs(options?: any) {
            return RegistryWebServiceApiFp(configuration).getAllTocs(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [toc] 
         * @param {string} [market] 
         * @param {string} [subscriber_id] 
         * @param {string} [page_size] 
         * @param {string} [page_number] 
         * @param {number} [added] added is represented as: 0 -&gt; empty value, 1 -&gt; true, 2 -&gt; false.
         * @param {number} [dismissed] dismissed is represented as: 0 -&gt; empty value, 1 -&gt; true, 2 -&gt; false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnknownSubscribers(toc?: string, market?: string, subscriber_id?: string, page_size?: string, page_number?: string, added?: number, dismissed?: number, options?: any) {
            return RegistryWebServiceApiFp(configuration).getUnknownSubscribers(toc, market, subscriber_id, page_size, page_number, added, dismissed, options)(fetch, basePath);
        },
    };
};

/**
 * RegistryWebServiceApi - object-oriented interface
 * @export
 * @class RegistryWebServiceApi
 * @extends {BaseAPI}
 */
export class RegistryWebServiceApi extends BaseAPI {
    /**
     * 
     * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
     * @param {AddUnknownSubscriberRequest} AddUnknownSubscriberRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistryWebServiceApi
     */
    public addUnknownSubscriber(AddUnknownSubscriberRequest: AddUnknownSubscriberRequest, options?: any) {
        return RegistryWebServiceApiFp(this.configuration).addUnknownSubscriber(AddUnknownSubscriberRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
     * @param {DismissUnknownSubscriberRequest} DismissUnknownSubscriberRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistryWebServiceApi
     */
    public dismissUnknownSubscriber(DismissUnknownSubscriberRequest: DismissUnknownSubscriberRequest, options?: any) {
        return RegistryWebServiceApiFp(this.configuration).dismissUnknownSubscriber(DismissUnknownSubscriberRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GetJourneyByID is used to return current journey by id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistryWebServiceApi
     */
    public getAllMarkets(options?: any) {
        return RegistryWebServiceApiFp(this.configuration).getAllMarkets(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary CheckShareToken is used to obtain data connected to token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistryWebServiceApi
     */
    public getAllTocs(options?: any) {
        return RegistryWebServiceApiFp(this.configuration).getAllTocs(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Auth is used to obtain JWT token, which should be used for Subscribe
     * @param {string} [toc] 
     * @param {string} [market] 
     * @param {string} [subscriber_id] 
     * @param {string} [page_size] 
     * @param {string} [page_number] 
     * @param {number} [added] added is represented as: 0 -&gt; empty value, 1 -&gt; true, 2 -&gt; false.
     * @param {number} [dismissed] dismissed is represented as: 0 -&gt; empty value, 1 -&gt; true, 2 -&gt; false.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistryWebServiceApi
     */
    public getUnknownSubscribers(toc?: string, market?: string, subscriber_id?: string, page_size?: string, page_number?: string, added?: number, dismissed?: number, options?: any) {
        return RegistryWebServiceApiFp(this.configuration).getUnknownSubscribers(toc, market, subscriber_id, page_size, page_number, added, dismissed, options)(this.fetch, this.basePath);
    }

}

/**
 * TelemetryWebServiceApi - fetch parameter creator
 * @export
 */
export const TelemetryWebServiceApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [market] 
         * @param {string} [subscriber_id] 
         * @param {string} [journey_id] 
         * @param {string} [toc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailedJourney(market?: string, subscriber_id?: string, journey_id?: string, toc?: string, options: any = {}): FetchArgs {
            const localVarPath = `/services/telemetry/v1/failed-journey`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (market !== undefined) {
                localVarQueryParameter['market'] = market;
            }

            if (subscriber_id !== undefined) {
                localVarQueryParameter['subscriber_id'] = subscriber_id;
            }

            if (journey_id !== undefined) {
                localVarQueryParameter['journey_id'] = journey_id;
            }

            if (toc !== undefined) {
                localVarQueryParameter['toc'] = toc;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [page] page represent page number what should be sent from 1 - first page.
         * @param {string} [size] page_size represents size of output array.
         * @param {string} [market] filters.
         * @param {string} [subscriber_id] 
         * @param {string} [journey_id] 
         * @param {string} [toc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailedJourneys(page?: string, size?: string, market?: string, subscriber_id?: string, journey_id?: string, toc?: string, options: any = {}): FetchArgs {
            const localVarPath = `/services/telemetry/v1/failed-journeys`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (market !== undefined) {
                localVarQueryParameter['market'] = market;
            }

            if (subscriber_id !== undefined) {
                localVarQueryParameter['subscriber_id'] = subscriber_id;
            }

            if (journey_id !== undefined) {
                localVarQueryParameter['journey_id'] = journey_id;
            }

            if (toc !== undefined) {
                localVarQueryParameter['toc'] = toc;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {string} [minutes_to_now] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMovingVehicles(minutes_to_now?: string, options: any = {}): FetchArgs {
            const localVarPath = `/services/telemetry/v1/moving-vehicles`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (minutes_to_now !== undefined) {
                localVarQueryParameter['minutes_to_now'] = minutes_to_now;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TelemetryWebServiceApi - functional programming interface
 * @export
 */
export const TelemetryWebServiceApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [market] 
         * @param {string} [subscriber_id] 
         * @param {string} [journey_id] 
         * @param {string} [toc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailedJourney(market?: string, subscriber_id?: string, journey_id?: string, toc?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetFailedJourneyResponse> {
            const localVarFetchArgs = TelemetryWebServiceApiFetchParamCreator(configuration).getFailedJourney(market, subscriber_id, journey_id, toc, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [page] page represent page number what should be sent from 1 - first page.
         * @param {string} [size] page_size represents size of output array.
         * @param {string} [market] filters.
         * @param {string} [subscriber_id] 
         * @param {string} [journey_id] 
         * @param {string} [toc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailedJourneys(page?: string, size?: string, market?: string, subscriber_id?: string, journey_id?: string, toc?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetFailedJourneysResponse> {
            const localVarFetchArgs = TelemetryWebServiceApiFetchParamCreator(configuration).getFailedJourneys(page, size, market, subscriber_id, journey_id, toc, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {string} [minutes_to_now] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMovingVehicles(minutes_to_now?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetMovingVehiclesResponse> {
            const localVarFetchArgs = TelemetryWebServiceApiFetchParamCreator(configuration).getMovingVehicles(minutes_to_now, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * TelemetryWebServiceApi - factory interface
 * @export
 */
export const TelemetryWebServiceApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [market] 
         * @param {string} [subscriber_id] 
         * @param {string} [journey_id] 
         * @param {string} [toc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailedJourney(market?: string, subscriber_id?: string, journey_id?: string, toc?: string, options?: any) {
            return TelemetryWebServiceApiFp(configuration).getFailedJourney(market, subscriber_id, journey_id, toc, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [page] page represent page number what should be sent from 1 - first page.
         * @param {string} [size] page_size represents size of output array.
         * @param {string} [market] filters.
         * @param {string} [subscriber_id] 
         * @param {string} [journey_id] 
         * @param {string} [toc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailedJourneys(page?: string, size?: string, market?: string, subscriber_id?: string, journey_id?: string, toc?: string, options?: any) {
            return TelemetryWebServiceApiFp(configuration).getFailedJourneys(page, size, market, subscriber_id, journey_id, toc, options)(fetch, basePath);
        },
        /**
         * 
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {string} [minutes_to_now] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMovingVehicles(minutes_to_now?: string, options?: any) {
            return TelemetryWebServiceApiFp(configuration).getMovingVehicles(minutes_to_now, options)(fetch, basePath);
        },
    };
};

/**
 * TelemetryWebServiceApi - object-oriented interface
 * @export
 * @class TelemetryWebServiceApi
 * @extends {BaseAPI}
 */
export class TelemetryWebServiceApi extends BaseAPI {
    /**
     * 
     * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
     * @param {string} [market] 
     * @param {string} [subscriber_id] 
     * @param {string} [journey_id] 
     * @param {string} [toc] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TelemetryWebServiceApi
     */
    public getFailedJourney(market?: string, subscriber_id?: string, journey_id?: string, toc?: string, options?: any) {
        return TelemetryWebServiceApiFp(this.configuration).getFailedJourney(market, subscriber_id, journey_id, toc, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Auth is used to obtain JWT token, which should be used for Subscribe
     * @param {string} [page] page represent page number what should be sent from 1 - first page.
     * @param {string} [size] page_size represents size of output array.
     * @param {string} [market] filters.
     * @param {string} [subscriber_id] 
     * @param {string} [journey_id] 
     * @param {string} [toc] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TelemetryWebServiceApi
     */
    public getFailedJourneys(page?: string, size?: string, market?: string, subscriber_id?: string, journey_id?: string, toc?: string, options?: any) {
        return TelemetryWebServiceApiFp(this.configuration).getFailedJourneys(page, size, market, subscriber_id, journey_id, toc, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
     * @param {string} [minutes_to_now] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TelemetryWebServiceApi
     */
    public getMovingVehicles(minutes_to_now?: string, options?: any) {
        return TelemetryWebServiceApiFp(this.configuration).getMovingVehicles(minutes_to_now, options)(this.fetch, this.basePath);
    }

}

/**
 * VehiclePisServiceApi - fetch parameter creator
 * @export
 */
export const VehiclePisServiceApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary CheckShareToken is used to obtain data connected to token
         * @param {string} calling_point_id_id id specifies the id of the entity
         * @param {string} [calling_point_id_type] type specifies the type of the id, for example it can be way to address stations in particular market.
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [calling_point_id_market] market defines the market this id belongs to.   - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDepartures(calling_point_id_id: string, calling_point_id_type?: string, calling_point_id_market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', options: any = {}): FetchArgs {
            // verify required parameter 'calling_point_id_id' is not null or undefined
            if (calling_point_id_id === null || calling_point_id_id === undefined) {
                throw new RequiredError('calling_point_id_id','Required parameter calling_point_id_id was null or undefined when calling getAllDepartures.');
            }
            const localVarPath = `/services/pis/v1/journey/departures/{calling_point_id.id}`
                .replace(`{${"calling_point_id.id"}}`, encodeURIComponent(String(calling_point_id_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (calling_point_id_type !== undefined) {
                localVarQueryParameter['calling_point_id.type'] = calling_point_id_type;
            }

            if (calling_point_id_market !== undefined) {
                localVarQueryParameter['calling_point_id.market'] = calling_point_id_market;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetCurrentRoute returns current route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentRoute(options: any = {}): FetchArgs {
            const localVarPath = `/services/pis/v1/journey/route`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} subscriber_name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourney(subscriber_name: string, options: any = {}): FetchArgs {
            // verify required parameter 'subscriber_name' is not null or undefined
            if (subscriber_name === null || subscriber_name === undefined) {
                throw new RequiredError('subscriber_name','Required parameter subscriber_name was null or undefined when calling getJourney.');
            }
            const localVarPath = `/services/pis/v1/subscriber/{subscriber.name}/journey`
                .replace(`{${"subscriber.name"}}`, encodeURIComponent(String(subscriber_name)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourneyAnnouncements(options: any = {}): FetchArgs {
            const localVarPath = `/services/pis/v1/announcements`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetJourneyStations returns stations with coordinates on route for map
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourneyStations(options: any = {}): FetchArgs {
            const localVarPath = `/services/pis/v1/journey/stations`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetJourneyByID is used to return current journey by id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosition(options: any = {}): FetchArgs {
            const localVarPath = `/services/pis/v1/position`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [subscriber_name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimpleJourney(subscriber_name?: string, options: any = {}): FetchArgs {
            const localVarPath = `/services/pis/v1/journey`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (subscriber_name !== undefined) {
                localVarQueryParameter['subscriber.name'] = subscriber_name;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetSharedJourney requests the journey by token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriber(options: any = {}): FetchArgs {
            const localVarPath = `/services/pis/v1/subscriber`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetVehicleInfo returns vehicle info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleInfo(options: any = {}): FetchArgs {
            const localVarPath = `/services/pis/v1/vehicle`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetActiveSubscriber returns any active journey for company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareMyTrain(options: any = {}): FetchArgs {
            const localVarPath = `/services/pis/v1/share-my-train`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehiclePisServiceApi - functional programming interface
 * @export
 */
export const VehiclePisServiceApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary CheckShareToken is used to obtain data connected to token
         * @param {string} calling_point_id_id id specifies the id of the entity
         * @param {string} [calling_point_id_type] type specifies the type of the id, for example it can be way to address stations in particular market.
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [calling_point_id_market] market defines the market this id belongs to.   - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDepartures(calling_point_id_id: string, calling_point_id_type?: string, calling_point_id_market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetAllDeparturesResponse> {
            const localVarFetchArgs = VehiclePisServiceApiFetchParamCreator(configuration).getAllDepartures(calling_point_id_id, calling_point_id_type, calling_point_id_market, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GetCurrentRoute returns current route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentRoute(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetCurrentRouteResponse> {
            const localVarFetchArgs = VehiclePisServiceApiFetchParamCreator(configuration).getCurrentRoute(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} subscriber_name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourney(subscriber_name: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetJourneyResponse> {
            const localVarFetchArgs = VehiclePisServiceApiFetchParamCreator(configuration).getJourney(subscriber_name, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourneyAnnouncements(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetJourneyAnnouncementsResponse> {
            const localVarFetchArgs = VehiclePisServiceApiFetchParamCreator(configuration).getJourneyAnnouncements(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GetJourneyStations returns stations with coordinates on route for map
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourneyStations(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetJourneyStationsResponse> {
            const localVarFetchArgs = VehiclePisServiceApiFetchParamCreator(configuration).getJourneyStations(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GetJourneyByID is used to return current journey by id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosition(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TrainPosition> {
            const localVarFetchArgs = VehiclePisServiceApiFetchParamCreator(configuration).getPosition(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [subscriber_name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimpleJourney(subscriber_name?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetJourneyResponse> {
            const localVarFetchArgs = VehiclePisServiceApiFetchParamCreator(configuration).getSimpleJourney(subscriber_name, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GetSharedJourney requests the journey by token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriber(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PisSubscriber> {
            const localVarFetchArgs = VehiclePisServiceApiFetchParamCreator(configuration).getSubscriber(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GetVehicleInfo returns vehicle info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleInfo(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetVehicleInfoResponse> {
            const localVarFetchArgs = VehiclePisServiceApiFetchParamCreator(configuration).getVehicleInfo(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GetActiveSubscriber returns any active journey for company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareMyTrain(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ShareMyTrainResponse> {
            const localVarFetchArgs = VehiclePisServiceApiFetchParamCreator(configuration).shareMyTrain(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * VehiclePisServiceApi - factory interface
 * @export
 */
export const VehiclePisServiceApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary CheckShareToken is used to obtain data connected to token
         * @param {string} calling_point_id_id id specifies the id of the entity
         * @param {string} [calling_point_id_type] type specifies the type of the id, for example it can be way to address stations in particular market.
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [calling_point_id_market] market defines the market this id belongs to.   - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDepartures(calling_point_id_id: string, calling_point_id_type?: string, calling_point_id_market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', options?: any) {
            return VehiclePisServiceApiFp(configuration).getAllDepartures(calling_point_id_id, calling_point_id_type, calling_point_id_market, options)(fetch, basePath);
        },
        /**
         * 
         * @summary GetCurrentRoute returns current route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentRoute(options?: any) {
            return VehiclePisServiceApiFp(configuration).getCurrentRoute(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} subscriber_name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourney(subscriber_name: string, options?: any) {
            return VehiclePisServiceApiFp(configuration).getJourney(subscriber_name, options)(fetch, basePath);
        },
        /**
         * 
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourneyAnnouncements(options?: any) {
            return VehiclePisServiceApiFp(configuration).getJourneyAnnouncements(options)(fetch, basePath);
        },
        /**
         * 
         * @summary GetJourneyStations returns stations with coordinates on route for map
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourneyStations(options?: any) {
            return VehiclePisServiceApiFp(configuration).getJourneyStations(options)(fetch, basePath);
        },
        /**
         * 
         * @summary GetJourneyByID is used to return current journey by id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosition(options?: any) {
            return VehiclePisServiceApiFp(configuration).getPosition(options)(fetch, basePath);
        },
        /**
         * 
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [subscriber_name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimpleJourney(subscriber_name?: string, options?: any) {
            return VehiclePisServiceApiFp(configuration).getSimpleJourney(subscriber_name, options)(fetch, basePath);
        },
        /**
         * 
         * @summary GetSharedJourney requests the journey by token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriber(options?: any) {
            return VehiclePisServiceApiFp(configuration).getSubscriber(options)(fetch, basePath);
        },
        /**
         * 
         * @summary GetVehicleInfo returns vehicle info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleInfo(options?: any) {
            return VehiclePisServiceApiFp(configuration).getVehicleInfo(options)(fetch, basePath);
        },
        /**
         * 
         * @summary GetActiveSubscriber returns any active journey for company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareMyTrain(options?: any) {
            return VehiclePisServiceApiFp(configuration).shareMyTrain(options)(fetch, basePath);
        },
    };
};

/**
 * VehiclePisServiceApi - object-oriented interface
 * @export
 * @class VehiclePisServiceApi
 * @extends {BaseAPI}
 */
export class VehiclePisServiceApi extends BaseAPI {
    /**
     * 
     * @summary CheckShareToken is used to obtain data connected to token
     * @param {string} calling_point_id_id id specifies the id of the entity
     * @param {string} [calling_point_id_type] type specifies the type of the id, for example it can be way to address stations in particular market.
     * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL'} [calling_point_id_market] market defines the market this id belongs to.   - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePisServiceApi
     */
    public getAllDepartures(calling_point_id_id: string, calling_point_id_type?: string, calling_point_id_market?: 'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US' | 'TFL', options?: any) {
        return VehiclePisServiceApiFp(this.configuration).getAllDepartures(calling_point_id_id, calling_point_id_type, calling_point_id_market, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GetCurrentRoute returns current route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePisServiceApi
     */
    public getCurrentRoute(options?: any) {
        return VehiclePisServiceApiFp(this.configuration).getCurrentRoute(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Auth is used to obtain JWT token, which should be used for Subscribe
     * @param {string} subscriber_name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePisServiceApi
     */
    public getJourney(subscriber_name: string, options?: any) {
        return VehiclePisServiceApiFp(this.configuration).getJourney(subscriber_name, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePisServiceApi
     */
    public getJourneyAnnouncements(options?: any) {
        return VehiclePisServiceApiFp(this.configuration).getJourneyAnnouncements(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GetJourneyStations returns stations with coordinates on route for map
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePisServiceApi
     */
    public getJourneyStations(options?: any) {
        return VehiclePisServiceApiFp(this.configuration).getJourneyStations(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GetJourneyByID is used to return current journey by id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePisServiceApi
     */
    public getPosition(options?: any) {
        return VehiclePisServiceApiFp(this.configuration).getPosition(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
     * @param {string} [subscriber_name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePisServiceApi
     */
    public getSimpleJourney(subscriber_name?: string, options?: any) {
        return VehiclePisServiceApiFp(this.configuration).getSimpleJourney(subscriber_name, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GetSharedJourney requests the journey by token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePisServiceApi
     */
    public getSubscriber(options?: any) {
        return VehiclePisServiceApiFp(this.configuration).getSubscriber(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GetVehicleInfo returns vehicle info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePisServiceApi
     */
    public getVehicleInfo(options?: any) {
        return VehiclePisServiceApiFp(this.configuration).getVehicleInfo(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GetActiveSubscriber returns any active journey for company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePisServiceApi
     */
    public shareMyTrain(options?: any) {
        return VehiclePisServiceApiFp(this.configuration).shareMyTrain(options)(this.fetch, this.basePath);
    }

}

